<template>
  <div>
    <CRow>
      <CCol sm="3">
        <CButton
          v-if="addButtonNeed"
          @click="addForm()"
          size="sm"
          color="linkedin"
          name="linkedin"
        >
          <!-- <i class="fa fa-plus-square"></i>&nbsp; -->
          <span>Tambah {{ title }}</span>
        </CButton>
      </CCol>
      <CCol sm="6" v-if="exportNeed" style="text-align: right">
        <label style="margin-bottom: 8px">Export</label>
        <br />
        <CButtonGroup role="group" size="sm" aria-label="Export">
          <CButton color="primary" @click="exportXls()"
            ><i class="fa fa-file-excel-o" aria-hidden="true"></i> Filtered
            Export</CButton
          >
        </CButtonGroup>
        <CButtonGroup
          role="group"
          size="sm"
          aria-label="Export"
          style="margin-left: 10px"
          v-if="enableExportAllUser"
        >
          <CButton
            color="primary"
            @click="
              exportCustomXls(
                'console/export/agent_information/export-all-user',
                'export_all_user.xlsx'
              )
            "
            ><i class="fa fa-file-excel-o" aria-hidden="true"></i> Semua Data</CButton
          >
        </CButtonGroup>
        <CButtonGroup
          role="group"
          size="sm"
          aria-label="Export"
          style="margin-left: 10px"
          v-if="enableExportAllIssue"
        >
          <CButton
            color="primary"
            @click="
              exportCustomXls(
                'console/export/product_issue/export-all-issue',
                'export_all_product_issue.xlsx'
              )
            "
            ><i class="fa fa-file-excel-o" aria-hidden="true"></i> Semua Data</CButton
          >
        </CButtonGroup>
      </CCol>
      <CCol sm="3" v-if="showNeed" style="text-align: right">
        <label style="margin-bottom: 8px">Tampilkan Data</label>
        <br />
        <CButtonGroup role="group" size="sm" aria-label="ShowHide">
          <CButton color="primary" @click="showHide()"
            ><i class="fa fa-columns" aria-hidden="true"></i> Show/Hide Columns</CButton
          >
        </CButtonGroup>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12"><br /></CCol>
    </CRow>
    <CRow>
      <CCol sm="9">&nbsp;</CCol>
      <CCol sm="3" v-if="visibilityShow">
        <JqxListBox
          style="float: right"
          @checkChange="myListBoxOnCheckChange($event)"
          :width="200"
          :autoHeight="true"
          :source="listBoxSource"
          :checkboxes="true"
        >
        </JqxListBox>
      </CCol>
      <CCol sm="12"><br /></CCol>
    </CRow>
    <!-- <CRow>
      <CCol sm="9">
        <h4>Catatan</h4>
        <p><strong>PERHATIKAN</strong> angka ROWS pada bagian paling bawah tabel, jika angka masih kurang dari 1200 (contoh: 1-10 of <strong>1189</strong>), berarti data aman untuk diEXPORT</p>
        <p><strong>Filtered Export</strong> - berfungsi untuk mengExport semua hasil data yang <strong>DICARI</strong> setelah mengetik kata kunci yang bersangkutan</p>
        <p><strong>JIKA</strong> ada kolom data yang kurang, silahkan check di <strong>TAMPILKAN DATA</strong> yang terletak disamping Export. <strong>FITUR INI</strong> juga dapat berfungsi untuk memodifikasi KOLOM DATA dan sistem akan <strong>mengikuti</strong> tampilan yang tertera di tabel untuk di <strong>"Filtered Export"</strong>.</p>
        <p>Cara <span class="button-color">COPY</span> data dalam baris/row, cukup dengan KLIK baris yang diinginkan (tabel akan otomatis menandai baris yang dipilih) lalu tahan <span class="button-color">SHIFT</span> atau <span class="button-color">CTRL</span> lalu klik ke baris yang diinginkan. Data yang akan diCOPY adalah semua data yang ada dalam baris yang bersangkutan, jika ingin <strong>memodifikasi</strong>, silahkan ke bagian <strong>TAMPILKAN DATA</strong>.</p>
      </CCol>
      <CCol sm="3" v-if="visibilityShow">
        <JqxListBox
          style="float: right"
          @checkChange="myListBoxOnCheckChange($event)"
          :width="200"
          :autoHeight="true"
          :source="listBoxSource"
          :checkboxes="true"
        >
        </JqxListBox>
      </CCol>
      <CCol sm="12"><br /></CCol>
    </CRow> -->
  </div>
</template>

<script>
import JqxListBox from "jqwidgets-scripts/jqwidgets-vue/vue_jqxlistbox.vue";

export default {
  name: "Table",
  components: { JqxListBox },
  props: {
    visibilityShow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    listBoxSource: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      default: "Table",
    },
    addButtonNeed: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showNeed: {
      type: Boolean,
      default() {
        return true;
      },
    },
    exportNeed: {
      type: Boolean,
      default() {
        return true;
      },
    },
    enableExportAllUser: {
      type: Boolean,
      default() {
        return false;
      },
    },
    enableExportAllIssue: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    addForm: function () {
      this.$emit("addForm");
    },
    myListBoxOnCheckChange: function (row) {
      this.$emit("myListBoxOnCheckChange", row);
    },
    exportCustomXls: function (url, file_name) {
      this.isLoading = true;
      this.axios({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    exportXls: function () {
      this.$emit("exportXls");
      this.isLoading = false;
    },
    showHide: function () {
      this.$emit("showHide");
    },
  },
};
</script>

<style>
.button-color {
  display: inline-block;
  background-color: #cacaca;
  color: #282828;
  border: 1px solid #333;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 4px;
  letter-spacing: 1px;
}
</style>
